module.exports = __webpack_public_path__ + "static/media/service3.76fe8ee9.svg";